module.exports = __webpack_public_path__ + "assets/img/8fdf6e8bb262a44af75a36b0b55c726c.png";